import React, { createContext, useContext, useState, useEffect } from 'react';

// Importar las traducciones
import esTranslations from '../locales/es.json';
import caTranslations from '../locales/ca.json';
import enTranslations from '../locales/en.json';

const LanguageContext = createContext();

const translations = {
    es: esTranslations,
    ca: caTranslations,
    en: enTranslations
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Intentar obtener el idioma del localStorage
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage && translations[savedLanguage]) {
            return savedLanguage;
        }

        // Detectar idioma del navegador
        const browserLanguage = navigator.language.split('-')[0];
        if (translations[browserLanguage]) {
            return browserLanguage;
        }

        // Por defecto catalán
        return 'ca';
    });

    const [translationsData, setTranslationsData] = useState(translations[language]);

    useEffect(() => {
        setTranslationsData(translations[language]);
        localStorage.setItem('language', language);

        // NO actualizar el atributo lang aquí - lo hace SEOMetaTags con la lógica SEO
        // document.documentElement.lang = language;
    }, [language]);

    const changeLanguage = (newLanguage) => {
        if (translations[newLanguage]) {
            setLanguage(newLanguage);
        }
    };

    const t = (key) => {
        const keys = key.split('.');
        let value = translationsData;

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                console.warn(`Translation key not found: ${key}`);
                return key; // Devolver la clave si no se encuentra la traducción
            }
        }

        return value;
    };

    const value = {
        language,
        changeLanguage,
        t,
        availableLanguages: ['ca', 'es', 'en']
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export default LanguageContext;
